import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-financials-link a')

export default function FinancialsLink() {
  const currentTimeframePath = useChartTimeframePathWatch()
  if (!currentTimeframePath)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        Financials
      </a>
    )

  return (
    <a href={`${currentTimeframePath}&ty=rv`} className="tab-link">
      Financials
    </a>
  )
}
